import type { ReactNode } from 'react';
import { Box, Container, Paper, RADIUS, Stack } from '../../ui';
import { BrandMark } from './BrandMark';

/**
 * MLP speaking as itself, outside the app: the sign-in screen and the error
 * page. A card under the mark, centred; on a phone the card is the whole screen.
 */
export function BrandCard({ children, role }: { children: ReactNode; role?: 'alert' }) {
  return (
    <Box
      styles={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: { xs: 'background.paper', sm: 'background.default' },
        px: { xs: 0, sm: 2 },
      }}
    >
      <Container as="main" maxWidth="xs" disableGutters>
        <Paper
          role={role}
          elevation={1}
          styles={{
            p: { xs: 3, sm: 4 },
            width: '100%',
            borderRadius: { xs: 0, sm: `${RADIUS.md}px` },
            boxShadow: { xs: 'none', sm: 1 },
          }}
        >
          <Stack spacing={2.5} styles={{ alignItems: 'center', textAlign: 'center' }}>
            <BrandMark size={72} />
            {children}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
